// pages/Configuracion.js - Versión actualizada con Tedee
import React, { useState, useEffect } from 'react';
import {
  Table,Empty,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Badge,
  Statistic,
  Card,
  Divider,
  InputNumber,
  Tabs,
  Descriptions,
  Alert
} from 'antd';
import {
  SettingOutlined,
  EditOutlined,
  SaveOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  GlobalOutlined,
  DollarOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  BankOutlined,
  IdcardOutlined,
  CalendarOutlined,
  NumberOutlined,
  CreditCardOutlined,
  SafetyOutlined,
  InfoCircleOutlined,
  ApiOutlined,
  KeyOutlined,
  LockOutlined,
  UnlockOutlined,
  WifiOutlined
} from '@ant-design/icons';
import axios from 'axios';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const Configuracion = () => {
  // Estados
  const [configuracion, setConfiguracion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState('general');

  // Cargar datos iniciales
  useEffect(() => {
    fetchConfiguracion();
  }, []);

  const fetchConfiguracion = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`${BASE_URL}/api/configuracion`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = response.data.data || {};
      
      // Transformar fechas
      if (data.FApertura) {
        data.FApertura = data.FApertura.split('T')[0];
      }
      if (data.FCierre) {
        data.FCierre = data.FCierre.split('T')[0];
      }
      if (data.UltCierre) {
        data.UltCierre = data.UltCierre.split('T')[0];
      }
      
        console.log(" data => ",data);
        

      setConfiguracion(data);
      
    } catch (error) {
      console.error('❌ Error cargando configuración:', error);
      message.error('Error al cargar la configuración');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    if (!configuracion) return;
    
    const formValues = {
      ...configuracion,
      // Asegurar que los campos numéricos sean números
      habin: configuracion.habin || 0,
      habdo: configuracion.habdo || 0,
      habtr: configuracion.habtr || 0,
      habcu: configuracion.habcu || 0,
      habqu: configuracion.habqu || 0,
      habpax: configuracion.habpax || 0,
      nreserva: configuracion.nreserva || 0,
      DigitCuentaAge: configuracion.DigitCuentaAge || 8,
      Tipo_Traspaso: configuracion.Tipo_Traspaso || 7,
      tipotraspaso: configuracion.tipotraspaso || 0,
      TedeeIdOrganizacionPuerta: configuracion.TedeeIdOrganizacionPuerta || '',
      TedeeIdPuerta: configuracion.TedeeIdPuerta || ''
    };
    
    form.setFieldsValue(formValues);
    setModalVisible(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const token = localStorage.getItem('token');

      const response = await axios.put(
        `${BASE_URL}/api/configuracion`,
        values,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Actualizar el estado local
      const updatedData = {
        ...response.data.data,
        ...values
      };
      
      setConfiguracion(updatedData);
      message.success('Configuración actualizada correctamente');
      setModalVisible(false);
      
    } catch (error) {
      console.error('❌ Error guardando configuración:', error);
      message.error(error.response?.data?.error || 'Error al guardar la configuración');
    }
  };

  // Renderizar vista de detalles
  const renderDetailView = () => {
    if (!configuracion) return <Empty description="No hay configuración cargada" />;

    const items = [
      {
        key: 'general',
        label: (
          <span>
            <HomeOutlined /> General
          </span>
        ),
        children: renderGeneralInfo(),
      },
      {
        key: 'contacto',
        label: (
          <span>
            <MailOutlined /> Contacto
          </span>
        ),
        children: renderContactoInfo(),
      },
      {
        key: 'contable',
        label: (
          <span>
            <BankOutlined /> Contabilidad
          </span>
        ),
        children: renderContableInfo(),
      },
      {
        key: 'habitaciones',
        label: (
          <span>
            <NumberOutlined /> Habitaciones
          </span>
        ),
        children: renderHabitacionesInfo(),
      },
      {
        key: 'reservas',
        label: (
          <span>
            Reservas
          </span>
        ),
        children: renderReservasInfo(),
      },      
      {
        key: 'fechas',
        label: (
          <span>
            <CalendarOutlined /> Fechas
          </span>
        ),
        children: renderFechasInfo(),
      },
      {
        key: 'legal',
        label: (
          <span>
            <SafetyOutlined /> Legal
          </span>
        ),
        children: renderLegalInfo(),
      },
      {
        key: 'tedee',
        label: (
          <span>
            <LockOutlined /> Tedee
          </span>
        ),
        children: renderTedeeInfo(),
      },
    ];

    return (
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        tabPosition="top"
        style={{ marginTop: 16 }}
      />
    );
  };

  const renderGeneralInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Información General" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="Nombre Hotel">
              <Tag color="blue" style={{ fontSize: 14 }}>
                {configuracion.Nombre || 'No especificado'}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Nombre Comercial">
              {configuracion.NombreComercial || 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="Razón Social">
              {configuracion.RazonSocial || 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="NIF/CIF">
              <Tag color="purple">{configuracion.nif || 'No especificado'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Código Centro">
              <Tag color="cyan">{configuracion.CodigoCentro || 'No especificado'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Código Mossos">
              {configuracion.CodigoMossos || 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="Agencia Factura Tasa" span={3}>
              {configuracion.AgenciaFacturaTasa || 'No especificado'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Dirección" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="Dirección" span={3}>
              <EnvironmentOutlined /> {configuracion.direccion || 'No especificada'}
            </Descriptions.Item>
            <Descriptions.Item label="Población">
              {configuracion.poblacion || 'No especificada'}
            </Descriptions.Item>
            <Descriptions.Item label="Provincia">
              {configuracion.provincia || 'No especificada'}
            </Descriptions.Item>
            <Descriptions.Item label="Código Postal">
              {configuracion.cp || 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="País" span={3}>
              {configuracion.pais || 'No especificado'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Web" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2 }} bordered>
            <Descriptions.Item label="Página Web" span={2}>
              <a href={configuracion.PaginaWeb} target="_blank" rel="noopener noreferrer">
                {configuracion.PaginaWeb || 'No especificada'}
              </a>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );

  const renderContactoInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Información de Contacto" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="Email" span={3}>
              <MailOutlined /> <a href={`mailto:${configuracion.email}`}>{configuracion.email || 'No especificado'}</a>
            </Descriptions.Item>
            <Descriptions.Item label="Fax" span={3}>
              <PhoneOutlined /> {configuracion.fax || 'No especificado'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Dirección Fiscal" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2 }} bordered>
            <Descriptions.Item label="Dirección Fiscal" span={2}>
              {configuracion.DireccionFiscal || 'No especificada'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );

  const renderContableInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Configuración Contable" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="IVA por Defecto">
              <Tag color="orange">{configuracion.ivadefecto || 'No especificado'}%</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="IVA Cargos">
              <Tag color="orange">{configuracion.ivadefectoCargos || 'No especificado'}%</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Tipo Traspaso">
              {configuracion.tipotraspaso === 0 ? 'No' : 'Sí'}
            </Descriptions.Item>
            <Descriptions.Item label="Tipo Traspaso Valor">
              <Tag color="purple">{configuracion.Tipo_Traspaso || 'No especificado'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Dígitos Cuenta Age">
              {configuracion.DigitCuentaAge || '8'}
            </Descriptions.Item>
            <Descriptions.Item label="Número Reserva">
              {configuracion.nreserva || '0'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Cuentas Contables" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="Cuenta Descuadre">
              <Tag color="gold">{configuracion.CuentaDescuadre || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Venta">
              <Tag color="green">{configuracion.cuentaventa || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Venta 2">
              <Tag color="green">{configuracion.cuentaventa2 || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Venta 3">
              <Tag color="green">{configuracion.cuentaventa3 || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Venta 4" span={3}>
              <Tag color="green">{configuracion.cuentaventa4 || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Descuento" span={3}>
              <Tag color="red">{configuracion.cuentadto || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Cuenta Entrega a Cuenta" span={3}>
              <Tag color="blue">{configuracion.CuentaEntregaACuenta || 'No especificada'}</Tag>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );

  const renderHabitacionesInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Capacidad de Habitaciones" bordered={false}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Statistic 
                title="Individuales" 
                value={configuracion.habin || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Dobles" 
                value={configuracion.habdo || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Triples" 
                value={configuracion.habtr || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Cuádruples" 
                value={configuracion.habcu || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#722ed1' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Quintuples" 
                value={configuracion.habqu || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#eb2f96' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Total Pax" 
                value={configuracion.habpax || 0}
                prefix={<NumberOutlined />}
                valueStyle={{ color: '#13c2c2' }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );

  const renderReservasInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Parametros" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2, md: 3 }} bordered>
            <Descriptions.Item label="Los picnics restan del servicio" span={3}>
               {configuracion.PicnicRestaServicio ? "Sí" : "No"}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );  

  const renderFechasInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Fechas del Hotel" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2 }} bordered>
            <Descriptions.Item label="Fecha Apertura">
              <Tag color="green">{configuracion.FApertura || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Fecha Cierre">
              <Tag color="red">{configuracion.FCierre || 'No especificada'}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Último Cierre" span={2}>
              <Tag color="blue">{configuracion.UltCierre || 'No especificado'}</Tag>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );

  const renderLegalInfo = () => (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Información Legal" bordered={false}>
          <Descriptions column={{ xs: 1, sm: 2 }} bordered>
            <Descriptions.Item label="Texto Factura" span={2}>
              <Paragraph style={{ 
                maxHeight: 200, 
                overflowY: 'auto',
                padding: 12,
                backgroundColor: '#f5f5f5',
                borderRadius: 4
              }}>
                {configuracion.textfac || 'No especificado'}
              </Paragraph>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );

  const renderTedeeInfo = () => {
    const hasTedeeConfig = configuracion.TedeeUrlApi || configuracion.Key_Tedee;
    
    return (
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card 
            title={
              <Space>
                <LockOutlined style={{ color: '#1890ff' }} />
                <span>Configuración Tedee - Cerraduras Inteligentes</span>
                {hasTedeeConfig ? (
                  <Badge status="success" text="Configurado" />
                ) : (
                  <Badge status="warning" text="No configurado" />
                )}
              </Space>
            }
            bordered={false}
            extra={
              <Tag color={hasTedeeConfig ? 'green' : 'orange'}>
                {hasTedeeConfig ? 'Conectado' : 'Sin conexión'}
              </Tag>
            }
          >
            <Descriptions column={{ xs: 1, sm: 2, md: 2 }} bordered>
              <Descriptions.Item label="URL API" span={2}>
                <Space>
                  <ApiOutlined />
                  <Text copyable={{ text: configuracion.TedeeUrlApi || '' }}>
                    {configuracion.TedeeUrlApi || 'No configurada'}
                  </Text>
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="Key API" span={2}>
                <Space>
                  <KeyOutlined />
                  {configuracion.Key_Tedee ? (
                    <Tag color="green">
                      <CheckCircleOutlined /> Configurada
                    </Tag>
                  ) : (
                    <Tag color="red">
                      <CloseCircleOutlined /> No configurada
                    </Tag>
                  )}
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="Cerraduras Asociadas" span={2}>
                <Space>
                  <LockOutlined />
                  <Tag color="purple">
                    {configuracion.TedeeCerraduras || '0'}
                  </Tag>
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="Key Puerta" span={2}>
                <Space>
                  <KeyOutlined />
                  {configuracion.Key_Tedee_Puerta ? (
                    <Tag color="green">
                      <CheckCircleOutlined /> Configurada
                    </Tag>
                  ) : (
                    <Tag color="red">
                      <CloseCircleOutlined /> No configurada
                    </Tag>
                  )}
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="ID Organización Puerta">
                <Space>
                  <IdcardOutlined />
                  <Text copyable={{ text: configuracion.TedeeIdOrganizacionPuerta || '' }}>
                    {configuracion.TedeeIdOrganizacionPuerta || 'No especificado'}
                  </Text>
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label="ID Puerta">
                <Space>
                  <IdcardOutlined />
                  <Text copyable={{ text: configuracion.TedeeIdPuerta || '' }}>
                    {configuracion.TedeeIdPuerta || 'No especificado'}
                  </Text>
                </Space>
              </Descriptions.Item>
            </Descriptions>

            <Divider />

            {/* <Alert
              message="Información de configuración Tedee"
              description={
                <div>
                  <p><strong>TedeeUrlApi:</strong> URL de la API de Tedee para la comunicación con las cerraduras</p>
                  <p><strong>Key_Tedee:</strong> Clave de API principal para autenticación con Tedee</p>
                  <p><strong>TedeeCerraduras:</strong> Número total de cerraduras Tedee configuradas en el sistema</p>
                  <p><strong>Key_Tedee_Puerta:</strong> Clave específica para la puerta principal o de acceso</p>
                  <p><strong>TedeeIdOrganizacionPuerta:</strong> ID de la organización en Tedee para la puerta principal</p>
                  <p><strong>TedeeIdPuerta:</strong> ID específico de la puerta en el sistema Tedee</p>
                </div>
              }
              type="info"
              showIcon
              icon={<InfoCircleOutlined />}
              style={{ marginTop: 16 }}
            /> */}

            {/* {!hasTedeeConfig && (
              <Alert
                message="Configuración pendiente"
                description="Para utilizar las funcionalidades de cerraduras inteligentes Tedee, debe configurar la URL de la API y las claves de acceso."
                type="warning"
                showIcon
                style={{ marginTop: 16 }}
              />
            )} */}
          </Card>
        </Col>
      </Row>
    );
  };

  

  return (
    <>
      <PageContainer
        title="Configuración del Hotel"
        subtitle={`${configuracion?.Nombre || 'Hotel'} - Gestión de parámetros`}
        icon={<SettingOutlined />}
        loading={loading}
        onRefresh={fetchConfiguracion}
        badgeCount={1}
        badgeStatus="processing"
        extra={
          <Space>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={handleEdit}
            >
              Editar Configuración
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchConfiguracion}
            >
              Actualizar
            </Button>
          </Space>
        }
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        

        {/* <Alert
          message="Configuración del Hotel"
          description="Esta sección muestra los parámetros de configuración del hotel. Puedes editar cualquier campo haciendo clic en 'Editar Configuración'."
          type="info"
          showIcon
          icon={<InfoCircleOutlined />}
          style={{ marginBottom: 24 }}
        /> */}

        {/* Vista de detalles */}
        {renderDetailView()}
      </PageContainer>

      {/* Modal para editar configuración */}
      <Modal
        title="Editar Configuración del Hotel"
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        width={900}
        okText="Guardar Cambios"
        cancelText="Cancelar"
        confirmLoading={loading}
        style={{ top: 20 }}
        bodyStyle={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            habin: 0,
            habdo: 0,
            habtr: 0,
            habcu: 0,
            habqu: 0,
            habpax: 0,
            nreserva: 0,
            DigitCuentaAge: 8,
            Tipo_Traspaso: 7,
            tipotraspaso: 0,
            TedeeIdOrganizacionPuerta: '',
            TedeeIdPuerta: ''
          }}
        >
          <Tabs
            defaultActiveKey="general"
            items={[
              {
                key: 'general',
                label: 'General',
                children: (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="Nombre"
                        label="Nombre del Hotel"
                        rules={[{ required: true, message: 'Ingrese el nombre del hotel' }]}
                      >
                        <Input placeholder="Nombre del hotel" prefix={<HomeOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="NombreComercial"
                        label="Nombre Comercial"
                      >
                        <Input placeholder="Nombre comercial" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="RazonSocial"
                        label="Razón Social"
                        rules={[{ required: true, message: 'Ingrese la razón social' }]}
                      >
                        <Input placeholder="Razón social" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="nif"
                        label="NIF/CIF"
                        rules={[
                          { required: true, message: 'Ingrese el NIF' },
                          { pattern: /^[A-Z0-9]{9}$/, message: 'Formato NIF inválido' }
                        ]}
                      >
                        <Input placeholder="NIF/CIF" prefix={<IdcardOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="CodigoCentro"
                        label="Código Centro"
                      >
                        <Input placeholder="Código del centro" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="CodigoMossos"
                        label="Código Mossos"
                      >
                        <Input placeholder="Código Mossos" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="AgenciaFacturaTasa"
                        label="Agencia Factura Tasa"
                      >
                        <Input placeholder="Agencia factura tasa" />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'direccion',
                label: 'Dirección',
                children: (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        name="direccion"
                        label="Dirección"
                        rules={[{ required: true, message: 'Ingrese la dirección' }]}
                      >
                        <Input placeholder="Calle, número" prefix={<EnvironmentOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="poblacion"
                        label="Población"
                        rules={[{ required: true, message: 'Ingrese la población' }]}
                      >
                        <Input placeholder="Ciudad" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="provincia"
                        label="Provincia"
                        rules={[{ required: true, message: 'Ingrese la provincia' }]}
                      >
                        <Input placeholder="Provincia" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cp"
                        label="Código Postal"
                        rules={[
                          { required: true, message: 'Ingrese el código postal' },
                          { pattern: /^[0-9]{5}$/, message: 'Código postal de 5 dígitos' }
                        ]}
                      >
                        <Input placeholder="Código postal" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="pais"
                        label="País"
                        rules={[{ required: true, message: 'Ingrese el país' }]}
                      >
                        <Input placeholder="País" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="DireccionFiscal"
                        label="Dirección Fiscal"
                      >
                        <Input placeholder="Dirección fiscal" />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'contacto',
                label: 'Contacto',
                children: (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          { required: true, message: 'Ingrese el email' },
                          { type: 'email', message: 'Email inválido' }
                        ]}
                      >
                        <Input placeholder="info@hotel.com" prefix={<MailOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="fax"
                        label="Fax"
                      >
                        <Input placeholder="Número de fax" prefix={<PhoneOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="PaginaWeb"
                        label="Página Web"
                      >
                        <Input placeholder="www.hotel.com" prefix={<GlobalOutlined />} />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'contable',
                label: 'Contabilidad',
                children: (
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        name="ivadefecto"
                        label="IVA por Defecto (%)"
                      >
                        <InputNumber 
                          placeholder="4" 
                          min={0} 
                          max={100}
                          style={{ width: '100%' }}
                          prefix={<DollarOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="ivadefectoCargos"
                        label="IVA Cargos (%)"
                      >
                        <InputNumber 
                          placeholder="4" 
                          min={0} 
                          max={100}
                          style={{ width: '100%' }}
                          prefix={<DollarOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="nreserva"
                        label="Número Reserva"
                      >
                        <InputNumber 
                          placeholder="0" 
                          min={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="tipotraspaso"
                        label="Tipo Traspaso"
                      >
                        <Select placeholder="Seleccione">
                          <Option value={0}>No</Option>
                          <Option value={1}>Sí</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="Tipo_Traspaso"
                        label="Tipo Traspaso Valor"
                      >
                        <InputNumber 
                          placeholder="7" 
                          min={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="DigitCuentaAge"
                        label="Dígitos Cuenta Age"
                      >
                        <InputNumber 
                          placeholder="8" 
                          min={1} 
                          max={10}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Divider>Cuentas Contables</Divider>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="CuentaDescuadre"
                        label="Cuenta Descuadre"
                      >
                        <Input placeholder="70500300" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cuentaventa"
                        label="Cuenta Venta"
                      >
                        <Input placeholder="48500001" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cuentaventa2"
                        label="Cuenta Venta 2"
                      >
                        <Input placeholder="48500001" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cuentaventa3"
                        label="Cuenta Venta 3"
                      >
                        <Input placeholder="48500001" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cuentaventa4"
                        label="Cuenta Venta 4"
                      >
                        <Input placeholder="48500001" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="cuentadto"
                        label="Cuenta Descuento"
                      >
                        <Input placeholder="76900000" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="CuentaEntregaACuenta"
                        label="Cuenta Entrega a Cuenta"
                      >
                        <Input placeholder="43000005" prefix={<BankOutlined />} />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },              
              {
                key: 'habitaciones',
                label: 'Habitaciones',
                children: (
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        name="habin"
                        label="Individuales"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<NumberOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="habdo"
                        label="Dobles"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<NumberOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="habtr"
                        label="Triples"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<NumberOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="habcu"
                        label="Cuádruples"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<NumberOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="habqu"
                        label="Quintuples"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<NumberOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="habpax"
                        label="Total Pax"
                      >
                        <InputNumber 
                          min={0} 
                          style={{ width: '100%' }}
                          prefix={<GlobalOutlined />}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'reservas',
                label: 'Reservas',
                children: (
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        name="PicnicRestaServicio"
                        label="Picnic resta servicio"
                        valuePropName="checked"
                      >
                          <Switch />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },

              {
                key: 'fechas',
                label: 'Fechas',
                children: (
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        name="FApertura"
                        label="Fecha Apertura"
                      >
                        <Input type="date" style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="FCierre"
                        label="Fecha Cierre"
                      >
                        <Input type="date" style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="UltCierre"
                        label="Último Cierre"
                      >
                        <Input type="date" style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'legal',
                label: 'Legal',
                children: (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        name="textfac"
                        label="Texto Factura"
                        tooltip="Texto legal que aparece en las facturas"
                      >
                        <TextArea 
                          rows={8} 
                          placeholder="Texto legal para facturas..."
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )
              },
              {
                key: 'tedee',
                label: (
                  <span>
                    <LockOutlined /> Tedee
                  </span>
                ),
                children: (
                  <Row gutter={16}>
                    <Col span={24}>
                      <Card size="small" style={{ marginBottom: 16, backgroundColor: '#e6f7ff' }}>
                        <Space>
                          <WifiOutlined style={{ color: '#1890ff', fontSize: 20 }} />
                          <Text strong>Configuración de cerraduras inteligentes Tedee</Text>
                        </Space>
                      </Card>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="TedeeUrlApi"
                        label="URL API Tedee"
                        tooltip="URL de la API de Tedee para la comunicación con las cerraduras"
                      >
                        <Input 
                          placeholder="https://api.tedee.com/v1" 
                          prefix={<ApiOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="Key_Tedee"
                        label="Key API Tedee"
                        tooltip="Clave de API principal para autenticación con Tedee"
                      >
                        <Input.Password 
                          placeholder="Ingrese la clave API" 
                          prefix={<KeyOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="TedeeCerraduras"
                        label="Cerraduras Asociadas"
                        tooltip="Lista de cerraduras Tedee asociadas al hotel (separadas por comas si son varias)"
                      >
                        <Input 
                          placeholder="Ej: Cerradura1, Cerradura2, Puerta Principal" 
                          prefix={<LockOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Divider>Configuración Puerta Principal</Divider>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="Key_Tedee_Puerta"
                        label="Key Tedee Puerta"
                        tooltip="Clave específica para la puerta principal o de acceso"
                      >
                        <Input.Password 
                          placeholder="Ingrese la clave de la puerta" 
                          prefix={<KeyOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="TedeeIdOrganizacionPuerta"
                        label="ID Organización Puerta"
                        tooltip="ID de la organización en Tedee para la puerta principal"
                      >
                        <Input 
                          placeholder="ID de organización" 
                          prefix={<IdcardOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="TedeeIdPuerta"
                        label="ID Puerta"
                        tooltip="ID específico de la puerta en el sistema Tedee"
                      >
                        <Input 
                          placeholder="ID de la puerta" 
                          prefix={<IdcardOutlined />}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      {/* <Alert
                        message="Información de configuración Tedee"
                        description={
                          <div style={{ fontSize: '13px' }}>
                            <p><strong>TedeeUrlApi:</strong> URL de la API de Tedee para la comunicación con las cerraduras</p>
                            <p><strong>Key_Tedee:</strong> Clave de API principal para autenticación con Tedee</p>
                            <p><strong>TedeeCerraduras:</strong> Número total de cerraduras Tedee configuradas en el sistema</p>
                            <p><strong>Key_Tedee_Puerta:</strong> Clave específica para la puerta principal o de acceso</p>
                            <p><strong>TedeeIdOrganizacionPuerta:</strong> ID de la organización en Tedee para la puerta principal</p>
                            <p><strong>TedeeIdPuerta:</strong> ID específico de la puerta en el sistema Tedee</p>
                          </div>
                        }
                        type="info"
                        showIcon
                        style={{ marginTop: 8 }}
                      /> */}
                    </Col>
                  </Row>
                )
              }
            ]}
          />
        </Form>
      </Modal>
    </>
  );
};

export default Configuracion;